const CACHE_BUST_QUERY_KEY = 'suite241_cache_bust';
const FIREBASE_MESSAGING_SCOPE_PATH = '/firebase-cloud-messaging-push-scope';

const isSameOriginScope = (scope: string): boolean => {
  if (typeof window === 'undefined') return false;

  try {
    return new URL(scope, window.location.href).origin === window.location.origin;
  } catch {
    return scope.startsWith(window.location.origin);
  }
};

const isFirebaseMessagingScope = (scope: string): boolean => {
  try {
    return new URL(scope, window.location.href).pathname.replace(/\/$/, '') === FIREBASE_MESSAGING_SCOPE_PATH;
  } catch {
    return scope.replace(/\/$/, '').includes(FIREBASE_MESSAGING_SCOPE_PATH);
  }
};

export const clearBrowserCachesForLatestVersion = async (): Promise<void> => {
  if (
    typeof navigator !== 'undefined'
    && 'serviceWorker' in navigator
    && typeof navigator.serviceWorker.getRegistrations === 'function'
  ) {
    const registrations = await navigator.serviceWorker.getRegistrations();

    await Promise.all(
      registrations
        .filter((registration) => isSameOriginScope(registration.scope))
        .filter((registration) => !isFirebaseMessagingScope(registration.scope))
        .map((registration) => registration.unregister())
    );
  }

  if (typeof window !== 'undefined' && 'caches' in window) {
    const cacheNames = await window.caches.keys();
    await Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName)));
  }
};

export const latestVersionUrl = (version?: string): string => {
  const url = new URL(window.location.href);
  url.searchParams.set(CACHE_BUST_QUERY_KEY, String(Date.now()));
  if (version) url.searchParams.set('suite241_version', version);

  return url.toString();
};

export const reloadToLatestSpaVersion = (version?: string): void => {
  window.location.replace(latestVersionUrl(version));
};
